import { Modal } from '../../../../core/components/templates/Modal';
import { Button } from '../../../../core/components/atoms/Button';
import { Typography } from '../../../../core/components/molecules/Typography';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

const SuccessModal = ({ isOpen, onClose, title }: SuccessModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='md'
      position='center'
      noPadding
    >
      <div className='flex flex-col'>
        <div className='px-6 py-6 text-center'>
          <Typography type='title' size='h3' className='text-center'>
            {title}
          </Typography>
        </div>
        <div className='flex flex-row items-center justify-center gap-lg px-6 py-4 shadow-level-2'>
          <Button variant='text' onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;
